import React, { useEffect } from 'react';
import { Moment } from 'moment';
import ReactPlaceholder from 'react-placeholder';
import { useSelector } from 'react-redux';
import PageWrapper from 'commons/src/components/containers/PageWrapper';
import { radonInsightPlaceholder } from 'commons/src/components/placeholder';
import { Store } from '../../../reducers';
import { BusinessRequestType as RequestType } from '../../../reducers/BusinessRequestType';
import OpeningHours from '../reportSelector/OpeningHoursTable';
import IAQInsight2BuildingInfo from './IAQInsight2BuildingInfo';
import dividerStyles from './IAQInsight2Divider.module.scss';
import IAQInsight2Header from './IAQInsight2Header';
import styles from './IAQInsight2ResultView.module.scss';
import IAQInsight2SensorMetrics from './IAQInsight2SensorMetrics';
import SensorsView from './SensorsView';

export type Props = {
    from: Moment;
    to: Moment;
};

const IAQInsight2ResultView = ({ from, to }: Props): React.ReactElement => {
    const { locationId, sensorReports, thresholds } = useSelector((state: Store) => state.iaqInsight);
    const buildings = useSelector((state: Store) => state.buildings.buildings);
    const locationsLoading = useSelector((state: Store) => state.locations.loading);
    const { dateFormat } = useSelector((state: Store) => state.userSettings);
    const loading = useSelector((state: Store) => state.requests[RequestType.FetchIaqInsightData].loading);

    useEffect(() => {
        if (!loading) {
            const element = document.getElementById('resultHeader');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [loading]);

    const building = locationId ? buildings[locationId] : undefined;
    const usageHours = building ? building.usageHours : {};
    const timeZone = (building && building.timezone) || 'UTC';

    return (
        <PageWrapper pageType="wide">
            <ReactPlaceholder ready={!loading && !locationsLoading} customPlaceholder={radonInsightPlaceholder}>
                {building && (
                    <div className={`form form__wide-container ${styles.reportContainer}`}>
                        <IAQInsight2Header building={building} />
                        <IAQInsight2BuildingInfo building={building} />
                        <div className={dividerStyles.divider} />
                        <OpeningHours
                            optionalBuildingProps={['openingHours']}
                            dateFormat={dateFormat}
                            validate={false}
                            building={building}
                        />
                        <div className={dividerStyles.divider} />
                        <IAQInsight2SensorMetrics sensorReports={sensorReports} thresholds={thresholds} />
                        <div className={dividerStyles.divider} />
                        <SensorsView
                            sensorReports={sensorReports}
                            thresholds={thresholds}
                            from={from}
                            to={to}
                            usageHours={usageHours}
                            timeZone={timeZone}
                        />
                    </div>
                )}
            </ReactPlaceholder>
        </PageWrapper>
    );
};

export default IAQInsight2ResultView;
